import React, { useEffect, useState } from "react";
import { notifyError, notifySuccess } from "../../helper";
import { TIMEZONES } from "../../constants/timezones";
import { DAYS, TOOLTIP } from "../../constants/constants";
import FormValidator from "../../FormValidator";
import {encode as base64_encode, decode as base64_decode} from 'base-64';
import client from "../../api";

const EditCalendarInfo = (props) => {
    const api = client();
    const [preferences,setPreferences] = useState({});
    const [contactEmails,setContactEmails] = useState();
    const [emailFromUrl, setEmailFromUrl] = useState();
    const [selectedDays,setSelectedDays] = useState([]);
    
    const validatorRules = {
        starttime: {
            rule1:{
                message: "Please Enter Valid Start Tme.",
                validator: (val) => !((/^([01]\d|2[0-3]):([0-5]\d)(:[0-5]\d)?$/).test(val))
            }
        },
        endtime: {
            rule1:{
                message: "Please Enter Valid End Time",
                validator: (val) => !((/^([01]\d|2[0-3]):([0-5]\d)(:[0-5]\d)?$/).test(val))
            }
        },
        timezone: {
            empty:"Please Select a timezone."
        },
        maxemailsparday:{
            rule1:{
                message: "Please Enter a Valid Max Emails par Day limit.",
                validator: (val) => !((/^[1-9]\d{0,4}$/).test(val))
            }
        },
        minutesbetweensend:{
            rule1:{
                message: "Please Enter a Valid Minutes between Sends.",
                validator: (val) => !((/^[1-9]\d{0,3}$/).test(val))
            }
        },
        maximumemailsatatime:{
            rule1:{
                message: "Please Enter a Valid Maximum Emails at a Time Limit.",
                validator: (val) => !((/^[1-9]\d{0,3}$/).test(val))
            }
        }
    }

    const validatorObject = new FormValidator(validatorRules);
    const [error, setError] = useState({});

    const removeError = (e) => {
        setError({ ...error, [e.target.name]: "" });
    }

    const fieldBlur = e => {
        const fieldError = validatorObject.validateFields(e.target.value, e.target.name);
        if (Object.keys(fieldError).length) setError({ ...error, ...fieldError });        
    }

    const fieldFocus = e => {
        removeError(e);     
    }

    const validateAllFields = (inputs) => {
        const v = validatorObject.validateFields(inputs);
        if(Object.keys(v).length === 0){
            return true;
        } else {
            setError({...v});
            return false;
        }       
    }

    const handleEmailChange = (e) => {
        window.location.href = `/campaign/calendar/${e.target.value}`;
    }

    const handleWeekDays = (day) => {
        let daysArr = preferences.weekDays !== null ? preferences.weekDays : [];
        if(!daysArr.length){
            daysArr.push(day);
        } else {
            if (daysArr.includes(day)) {
                daysArr = daysArr.filter((d) => d !== day);
            } else {
                daysArr.push(day);
            }            
        }
        setSelectedDays([...daysArr]);
        setPreferences({...preferences,weekDays:daysArr});        
    }

    const handleFormField = (obj) => {
        setPreferences({...preferences,...obj});
    }
    
    const convertinFlatObject = (obj) => {

        const startTime = new Date();
        const endTime = new Date();
        const midTime = new Date();
        midTime.setHours(0);
        midTime.setMinutes(0);
        midTime.setSeconds(0);
        const midNight = parseInt(midTime.getTime());
        
        startTime.setTime(obj.work_time.from_time*60*1000 + midNight);
        endTime.setTime(obj.work_time.to_time*60*1000 + midNight);
        
        const startHours = startTime.getHours();
        const startMinuts = startTime.getMinutes();

        const endHours = endTime.getHours();
        const endMinuts = endTime.getMinutes();
        

        //const newstartTime = new Date((startTime.getTime() + midTime.getTime())/1000);
        
        obj.work_days !== null && setSelectedDays([...(obj.work_days)]);
        return {
            email:base64_decode(props.email),
            weekDays:obj.work_days,
            starttime:`${startHours.toString().padStart(2,'0')}:${startMinuts.toString().padStart(2,'0')}`,
            endtime:`${endHours.toString().padStart(2,'0')}:${endMinuts.toString().padStart(2,'0')}`,
            timezone:obj.work_time.time_zone,
            maxemailsparday:obj.work_load_capacity.max_job_in_single_day,
            minutesbetweensend:obj.work_load_capacity.minimum_time_between_job_bursts,
            maximumemailsatatime:obj.work_load_capacity.max_job_in_single_burst,
            strategy:obj.work_load_capacity.strategy
        }
    }
    const rearrangeData = (inputData) => {
        const start = new Date();
        const end = new Date();
        const midnight = new Date();

        start.setHours(parseInt((inputData.starttime).split(':')[0]));
        start.setMinutes(parseInt((inputData.starttime).split(':')[1]));
        start.setSeconds(0);
        
        end.setHours(parseInt((inputData.endtime).split(':')[0]));
        end.setMinutes(parseInt((inputData.endtime).split(':')[1]));
        end.setSeconds(0);
        
        midnight.setHours(0);
        midnight.setMinutes(0);
        midnight.setSeconds(0);

        let rearrangeObj = {
            "email": inputData.email,
            "sending_preference": {
                "work_days": inputData.weekDays,
                "work_time": {
                    "time_zone": inputData.timezone,
                    "from_time": (start.getTime() - midnight.getTime())/(60*1000),
                    "to_time": (end.getTime() - midnight.getTime())/(60*1000)
                },
                "work_load_capacity": {
                    "strategy": inputData.strategy,
                    "max_job_in_single_burst": parseInt(inputData.maximumemailsatatime),
                    "minimum_time_between_job_bursts": parseInt(inputData.minutesbetweensend),
                    "max_job_in_single_day": parseInt(inputData.maxemailsparday)
                }
            }            
        }
        return rearrangeObj;

    }
    const savePreferencesData = async () => {
        
        try{
            if(validateAllFields(preferences)){
                const updatedObj = rearrangeData(preferences);
                const response = await api.post('/v1/mailAccount/preference/update',{...updatedObj});
                if(response.status === 200 || response.status === 201){
                    notifySuccess('Preferences are updated successfully.');
                    let newObj = convertinFlatObject({...updatedObj});
                    setPreferences({...newObj});
                    setTimeout(()=>{
                        window.location.href = window.location.href;
                    },500);
                }
            }
        } catch(error){
            if(error.status === 400) if(error.status === 400) notifyError('Bad Request. Not able to update Preferences. Please try again'); 
        }
        setTimeout(()=>{
            props.setEditMode(false);
        },1500);        
    }
    const handleCancel = () => {
        props.setEditMode(false);
    }
    useEffect(()=>{
        const fetchPreferences = async () => {
            try{
                const response = await api.post('/v1/mailAccount/preference',{
                    email: base64_decode(props.email)
                });
                if(response.status === 200 || response.status === 201){
                    let flatObj = convertinFlatObject(response.data.data);
                    setPreferences(flatObj);                    
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Not able to fetch Preferences for given email. Please try again');
            }
        }
        if(!Object.keys(preferences).length){
            fetchPreferences();             
        }
    },[]);

    useEffect(()=>{
        const getContactEmails = async () => {
            try{
                const response = await api.get('/v1/mailAccount/list');
                if(response.status === 200 || response.status === 201){
                    setContactEmails(response.data.data);                    
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400){
                    notifyError('Bad Request. Not able to fetch Contact Emails. Please try again');
                }  
            }
        }

        if(!contactEmails){
            getContactEmails();
        }
    },[api, contactEmails, setContactEmails]);

    useEffect(()=>{
        if(!emailFromUrl){
            setEmailFromUrl(props.email);
        }
    },[emailFromUrl, props.email, setEmailFromUrl]);
    
    return(<>
        <div className="edit-calendar-info">
            <div className="field-wrap">
                <label className="label-xs">Mail Account</label>
                <select className="selectbox" onChange={handleEmailChange} value={emailFromUrl !== undefined && emailFromUrl}>
                {contactEmails && contactEmails.map((row,i)=>(<option 
                    key={i} 
                    value={base64_encode(row.email)}
                    >{row.email}</option>))}
                </select>
            </div>
            <div className="field-wrap">
                <label className="label-xs">Blocked out days</label>
                <ul className="week-days">
                    {DAYS.map((d,i)=>(<li 
                        key={i} 
                        onClick={()=>{handleWeekDays(i)}} 
                        className={selectedDays.includes(i)?'selected':''}>
                            {d.slice(0,2)}
                        </li>))}
                </ul>
            </div>
            <div className="field-wrap">
                <label className="label-xs">Start Time</label>
                <input 
                    aria-label="Start Time" 
                    type="time" 
                    name='starttime' 
                    placeholder="00:00:00 AM"
                    value={Object.keys(preferences).length && (preferences.starttime)}
                    onFocus={(e)=>{
                        fieldFocus(e);
                    }}
                    onBlur={(e)=>{
                        fieldBlur(e);
                    }}
                    onChange={(e)=>{
                        handleFormField({starttime:e.target.value});
                    }}
                    />
                {error.starttime && <span className="validation-error">{error.starttime}</span>}
            </div>
            <div className="field-wrap">
                <label className="label-xs">End Time</label>
                <input 
                    aria-label="End Time" 
                    type="time" 
                    name='endtime' 
                    placeholder="00:00 AM"
                    value={Object.keys(preferences).length && (preferences.endtime)}
                    onFocus={(e)=>{
                        fieldFocus(e);
                    }}
                    onBlur={(e)=>{
                        fieldBlur(e);
                    }}
                    onChange={(e)=>{
                        handleFormField({endtime:e.target.value});
                    }} />
                {error.endtime && <span className="validation-error">{error.endtime}</span>}
            </div>
            <div className="field-wrap">
                <label className="label-xs">Timezone </label>
                <select 
                    className="selectbox" 
                    name="timezone"
                    onFocus={(e)=>{
                        fieldFocus(e);
                    }}
                    onBlur={(e)=>{
                        fieldBlur(e);
                    }}
                    onChange={(e)=>{
                        handleFormField({timezone:e.target.value});
                    }} 
                    value={Object.keys(preferences).length && preferences.timezone}>
                        <option value={''}>Timezone</option>
                        {TIMEZONES.map((zone,i)=>(<option key={i} value={zone}>{zone}</option>))}
                </select>
                {error.timezone && <span className="validation-error">{error.timezone}</span>}
            </div>
            <div className="field-wrap">
                <label className="label-xs">Max emails per day
                    <div className="tooltip">
                        <i className='bx bx-info-circle'></i>
                        <div className="tooltip-content"> 
                            
                            {typeof props?.email !== "undefined" && (base64_decode(props?.email).includes('@gmail.com') ? TOOLTIP.max_emails_per_day_gmail : TOOLTIP.max_emails_per_day_smtp) }
                        </div>
                    </div>
                </label>
                <input 
                    type="text" 
                    name="maxemailsparday" 
                    placeholder="e.g. 1000"
                    value={Object.keys(preferences).length && preferences.maxemailsparday} 
                    onFocus={(e)=>{
                        fieldFocus(e);
                    }}
                    onBlur={(e)=>{
                        fieldBlur(e);
                    }}
                    onChange={(e)=>{
                        handleFormField({maxemailsparday:e.target.value});
                    }}/>
                    {error.maxemailsparday && <span className="validation-error">{error.maxemailsparday}</span>}
            </div>
            <div className="field-wrap">
                <label className="label-xs">Strategy</label>
                <select 
                    className="selectbox" 
                    name="strategy" 
                    onFocus={(e)=>{
                        fieldFocus(e);
                    }}
                    onBlur={(e)=>{
                        fieldBlur(e);
                    }}
                    onChange={(e)=>{
                        handleFormField({strategy:e.target.value});
                    }}
                    value={Object.keys(preferences).length && preferences.strategy}>
                    <option value={""} disabled>Select Strategy</option>
                    <option value={"space_out_over_the_day"} disabled>Space out over the day</option>
                    <option value={"send_as_fast_as_possible"}>Send as fast as possible</option>                    
                </select>
                {error.strategy && <span className="validation-error">{error.strategy}</span>}
            </div>
            <div className="field-wrap">
                <label className="label-xs">Minutes between sends
                    <div className="tooltip">
                        <i className='bx bx-info-circle'></i>
                        <div className="tooltip-content">
                            {TOOLTIP.minutes_between_sends}
                        </div>
                    </div>
                </label>
                <input 
                    type="text" 
                    name="minutesbetweensend" 
                    placeholder="e.g. 5"
                    value={Object.keys(preferences).length && preferences.minutesbetweensend} 
                    onFocus={(e)=>{
                        fieldFocus(e);
                    }}
                    onBlur={(e)=>{
                        fieldBlur(e);
                    }}
                    onChange={(e)=>{
                        handleFormField({minutesbetweensend:e.target.value});
                    }} />
                    {error.minutesbetweensend && <span className="validation-error">{error.minutesbetweensend}</span>}
            </div>
            <div className="field-wrap">
                <label className="label-xs">Maximum emails to send at a time 
                    <div className="tooltip">
                        <i className='bx bx-info-circle'></i>
                        <div className="tooltip-content">
                            {TOOLTIP.maximum_emails_to_send_at_a_time}
                        </div>
                    </div>
                </label>
                <input 
                    type="text" 
                    name="maximumemailsatatime" 
                    placeholder="e.g. 10" 
                    value={Object.keys(preferences).length && preferences.maximumemailsatatime} 
                    onFocus={(e)=>{
                        fieldFocus(e);
                    }}
                    onBlur={(e)=>{
                        fieldBlur(e);
                    }}
                    onChange={(e)=>{
                        handleFormField({maximumemailsatatime:e.target.value});
                    }} />
                    {error.maximumemailsatatime && <span className="validation-error">{error.maximumemailsatatime}</span>}
            </div>
            <div className="field-wrap btn-controls">
                <button type="button" className="primary-btn" onClick={()=>{savePreferencesData()}}>Save</button>
                <button 
                    type="button" 
                    className="cancel-btn"
                    onClick={()=>{
                      handleCancel()
                    }}>Cancel</button>
            </div>
        </div>
    </>);
}

export default EditCalendarInfo;